import React from 'react';
import NoData from 'assets/no_data.svg?react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { GRID_DEFAULT_HEIGHT } from '../ui/constants';

const StyNoDataContainer = styled(Box, {
    name: 'StyNoDataContainer',
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    fontSize: '2em',

    '& p': {
        marginLeft: '1rem',
        lineHeight: 'normal',
    },
});

type Props = {
    message?: string;
};

const NoDataComponent = ({ message }: Props) => {
    const { t } = useTranslation();
    return (
        <Flex
            align="center"
            sx={{
                minHeight: GRID_DEFAULT_HEIGHT,
            }}
        >
            <StyNoDataContainer>
                <NoData />
                <p>{message ? message : t('common.noData')}</p>
            </StyNoDataContainer>
        </Flex>
    );
};

export default NoDataComponent;
